var map = {
	"./arctic-map (Copiar).png": 7222,
	"./arctic-map.png": 5633,
	"./balticsea-map (Copiar).png": 6692,
	"./balticsea-map.png": 3247,
	"./blacksea-map (Copiar).png": 4244,
	"./blacksea-map.png": 9199,
	"./global-map (Copiar).png": 7165,
	"./global-map.png": 6908,
	"./ibi-map.png": 5109,
	"./ibiold-map.png": 4296,
	"./medsea-map (Copiar).png": 6687,
	"./medsea-map.png": 3158,
	"./nws-map (Copiar).png": 1308,
	"./nws-map.png": 6039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 390;